import { render } from "./MysteriousStorage.vue?vue&type=template&id=0db4d872&scoped=true"
import script from "./MysteriousStorage.vue?vue&type=script&lang=js"
export * from "./MysteriousStorage.vue?vue&type=script&lang=js"

import "./MysteriousStorage.vue?vue&type=style&index=0&id=0db4d872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db4d872"]])

export default __exports__